import { useEffect, useState } from 'react'
import { listenBroadcastChannel, sendBroadcastMessage } from '../services/broadcastService'
import { App } from '../types/App'

const KEY = 'update-app-data'

export const updateAppData = (app: App) => sendBroadcastMessage(KEY, app)

export const useAppData = () => {
  const [app, setApp] = useState<App>(window.App)

  useEffect(
    () =>
      listenBroadcastChannel(KEY, (app: App) => {
        window.App = app
        setApp(window.App)
      }),
    [],
  )

  return app
}
